/* eslint-disable */
import { definitions } from '@src/types/schema'
import { any } from 'ramda'
import { useSelector } from 'react-redux'

import { rolesMapSelector, rolesSelector } from '../redux/selector'

export type RolesModule = typeof import('../constants/userRoles')

export type roleConstants = RolesModule[keyof RolesModule]

function useCheckRoles() {
  const roles = useSelector(rolesSelector) as unknown as roleConstants[] | undefined
  const rolesMap = useSelector(rolesMapSelector)

  /**
   * Returns true if at least one of user roles of the list match the predicate.
   *
   * @param predicate array of roles "['ADMIN', 'MODERATOR']", a string, RegExp or a predicate function
   *
   */
  function amI(
    predicate:
      | roleConstants[]
      | roleConstants
      | RegExp
      | ((
          roles: roleConstants[],
          roles_map: definitions['ConferencePublicationAuthorAuthInfoDTO']['roles_map']
        ) => boolean)
  ) {
    if (!predicate) {
      return null
    }

    const safeRolesMap = (rolesMap || {}) as definitions['ConferencePublicationAuthorAuthInfoDTO']['roles_map']
    const safeRoles =
      roles && roles.length
        ? roles
        : ((rolesMap ? Object.keys(rolesMap) : []) as roleConstants[])

    if (!safeRoles.length && !Object.keys(safeRolesMap || {}).length) {
      return false
    }

    if (Array.isArray(predicate)) {
      return any(
        role => Object.prototype.hasOwnProperty.call(safeRolesMap, role) || safeRoles.includes(role),
        predicate
      )
    }

    if (typeof predicate === 'string') {
      return Object.prototype.hasOwnProperty.call(safeRolesMap, predicate) || safeRoles.includes(predicate)
    }

    if (predicate instanceof RegExp) {
      return any(role => predicate.test(role), safeRoles)
    }

    if (typeof predicate === 'function') {
      return predicate(safeRoles, safeRolesMap)
    }

    return false
  }

  return { amI, userInfoLoading: !roles && !rolesMap, roles, rolesMap }
}

export default useCheckRoles